import {getSettings} from "@/http/services/http-services-settings";
import {AppComponent} from "@/components/app-component";
import {getComponentByName} from "@/helpers/web-component-helper";
import {initCesium} from "@/modules/cesium/cesium";
import {getDefaultSession} from "@/helpers/user-session-helper";
import {hideButtonsBySettings} from "@/helpers/button-helper";
import {initFeedback} from "@/helpers/feedback-helper";
import {getBySelector, hideElementsBySelector} from "@/helpers/element-helper";
import {checkAdfs} from "@/helpers/auth/adfs-helper";
import Swal from "sweetalert2";
import moment from "moment";
moment.locale('nl')

export function initSettings(userSettings) {
    getSettings().then( settings => {
        window.websiteID = settings.bookmarkID
        window.settings = settings

        window.isAdfs = false
        checkAdfs(settings.AdfsRedirect)

        if(moment(settings.AvailableFrom, 'DD-MM-YYYY').isAfter(moment().startOf('day'))) {
            Swal.fire({
                buttonsStyling: false,
                title: 'Deze website is nog niet beschikbaar',
                type: 'warning',
                showCancelButton: false,
                showConfirmButtonButton: false,
                showDenyButton: false,
                customClass: {
                    confirmButton: 'btn btn-danger btn-lg',
                    cancelButton: 'btn btn-default btn-lg'
                },
                reverseButtons: true,
            })

            return
        }

        if(moment().startOf('day').isAfter(moment(settings.AvailableUntil, 'DD-MM-YYYY'))) {
            Swal.fire({
                buttonsStyling: false,
                title: 'Deze website is niet meer beschikbaar',
                type: 'warning',
                showCancelButton: false,
                showConfirmButtonButton: false,
                showDenyButton: false,
                customClass: {
                    confirmButton: 'btn btn-danger btn-lg',
                    cancelButton: 'btn btn-default btn-lg'
                },
                reverseButtons: true,
            })

            return
        }

        AppComponent.defineElements();

        if (settings.FeedbackType !== 0) {
            document.querySelector(".ol-overviewmap").style.bottom = "105px"
        }

        hideButtonsBySettings(settings.buttons)

        if(settings.buttons[3].Gebruiker) {
            if(userSettings.isIpAddress) {
                getComponentByName('header-login').classList.remove('d-none')
                getComponentByName('header-logout').classList.add('d-none')

                getBySelector(`[data-key="openLogIn"]`).replaceWith('Log in met een gebruikersaccount. U bevindt zich in een vertrouwde omgeving: ' + userSettings.Username)
            } else {
                if (window.sessionStorage.accessToken === undefined) {
                    getComponentByName('header-login').classList.remove('d-none')
                    getComponentByName('header-logout').classList.add('d-none')
                } else {
                    getComponentByName('header-logout').classList.remove('d-none')
                    getComponentByName('header-login').classList.add('d-none')
                }
            }
        } else {
            hideElementsBySelector('.divProfileMenu')
        }

        // BrowserNavigationTitle
        document.title = settings.BrowserNavigationTitle

        const defaultUserSession = getDefaultSession()
        if(window.urlParamsObject.mode === '3D' || (defaultUserSession && defaultUserSession.Mode === 1)) {
            initCesium(true)
            document.querySelector('cesium-enable').firstChild.firstChild.classList.add('active')
            document.querySelector('layer-info-tools-3d').classList.remove('d-none')
            document.querySelector('layer-info-tools-measure').classList.add('d-none')
        }

        if(settings.FeedbackType) {
            initFeedback(settings)
        }
    })
}

export function getWhiteListExtensions() {
    return '.' + window.settings.file_extension_white_list.replaceAll(';', ',.')
}
